<template>
  <div>
    <div class="page-header page-header-small clear-filter">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg11.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <h1 class="h1-seo">Contact</h1>
        </div>
    </div>
<section id="company" class="section">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Contact us</h2>
            <h5 class="description text-primary">
              <p><i class="now-ui-icons ui-1_email-85 pr-4"></i>info@alphabasedcapital.com</p>
              <p><i class="now-ui-icons tech_mobile pr-4"></i>+31 (0)85 064 5729</p>
              <p><i class="now-ui-icons location_pin pr-4"></i>Nevelgaarde 8, 3436ZZ, Nieuwegein, the Netherlands</p>
            </h5>
            <div class="map-responsive"><iframe width="100%" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=Nevelgaarde 8, 3436ZZ, Nieuwegein&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><a href="https://www.embedgooglemap.net/blog/nordvpn-coupon-code/">embedgooglemap.net</a></div>
          </div>
        </div>
        </div>
      </section>
    </div>
</template>
<script>
import { Parallax } from '@/components';
import { Button, FormGroupInput } from '@/components';
export default {
  bodyClass: 'index-page',
  components: {
    Parallax,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        message: ''
      }
    };
  }
}
</script>
<style>
.map-responsive{
    overflow:hidden;
    padding-bottom:56.25%;
    position:relative;
    height:0;
}
.map-responsive iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
}
</style>
